import * as ReactDOM from 'react-dom';
import { ICellRendererComp, ICellRendererParams } from 'ag-grid-community';

export class CellCustomRenderer implements ICellRendererComp {
    eGui!: HTMLDivElement;

    // gets called once before the renderer is used
    init(params: ICellRendererParams) {
        this.eGui = document.createElement('div');
        this.setCell(params);
    }

    setCell(params: ICellRendererParams) {
        ReactDOM.render(<div>{params}</div>, this.eGui);
    }

    getGui() {
        return this.eGui;
    }

    // gets called whenever the cell refreshes
    refresh(params: ICellRendererParams) {
        this.setCell(params);

        // return true to tell the grid we refreshed successfully
        return true;
    }

    getValueToDisplay(params: ICellRendererParams) {
        return params.valueFormatted ? params.valueFormatted : params.value;
    }
}
